<template>
  <Breadcrumbs
      title="Working Day Calendar"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Working Day Calendar', path: '/working-day-calendar' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <workingDayCalendar/>
    </div>
  </div>
</template>

<script>
import workingDayCalendar from "@/pages/master_data/working_day_calendar/working_day_calendar_form.vue";

export default {
  components: {
    workingDayCalendar
  }
}
</script>